import { z } from "zod";
import { PageStatusSchema, PageMetafieldsSchema, PageEditorSchema } from "./page";

// Page version schema (for version history)
export const PageVersionSchema = z.object({
    id: z.number(),
    path: z.string(),
    status: PageStatusSchema,
    metafields: PageMetafieldsSchema,
    editor: PageEditorSchema.nullable(),
    created_at: z.string(),
});

// Restore version request body
export const RestoreVersionRequestSchema = z.object({
    version_id: z.number(),
});

// TypeScript type exports
export type PageVersion = z.infer<typeof PageVersionSchema>;
export type RestoreVersionRequest = z.infer<typeof RestoreVersionRequestSchema>;

